import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";
import http from "./HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/booking/list";
const apiStatusEndpoint = API_BASE_URL_ENV() + "/booking/status";
const apiCancelEndpoint = API_BASE_URL_ENV() + "/booking/cancel";

export default class BookingRequestsService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	toggleStatus = (id, data) => {
		return http.put(`${apiStatusEndpoint}/${id}`, data);
	};
	cancelStatus = (id, data) => {
		return http.put(`${apiCancelEndpoint}/${id}`, data);
	};
}
